Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOrdinals = void 0;
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var useOrdinals = exports.useOrdinals = function useOrdinals() {
  var _i18n$language;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var _lang = ((_i18n$language = i18n.language) == null ? void 0 : _i18n$language.split('_')[0]) || 'en';
  var _rules = new Intl.PluralRules(_lang, {
    type: 'ordinal'
  });
  var _suffixes = {
    zero: '',
    one: t('ordinals:one'),
    two: t('ordinals:two'),
    few: t('ordinals:few'),
    other: t('ordinals:other'),
    many: t('ordinals:other')
  };
  var suffix = function suffix(number) {
    if (number === 0) return _suffixes['zero'];
    return _suffixes[_rules.select(number)];
  };
  return {
    suffix: suffix
  };
};